import { Component } from '@angular/core';
import { ContentPageLayout } from '../../shared/layouts/content-page-layout/content-page-layout';

@Component({
  selector: 'app-inventory',
  imports: [ContentPageLayout],
  templateUrl: './inventory.html',
  styleUrl: './inventory.css',
})
export class Inventory {}
